module.exports = __webpack_public_path__ + "img/ch.4bcbe9d0.svg";